import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path, pathOr, prop, propEq, assocPath, find } from 'ramda';

import { WAITING_EVENT_TYPE, PROBATION_EVENT_TYPE } from 'constants/events';
import EventProbationForm from './EventProbationForm';
import EventWaitingForWorkForm from './EventWaitingForWorkForm';

const workingMapBeforeSubmit = (values, props) => {
    return ({
        id: values.id,
        contact: {
            type: path(['event', 'type'], props),
            project: path(['event', 'details', 'project', 0, 'id'], props),
            person: path(['event', 'details', 'people', 0, 'id'], props),
            employee: path(['event', 'details', 'responsible', 0, 'id'], props),
            description: path(['event', 'comment'], props),
        },
        details: {
            dateTo: path(['event', 'details', 'eventDate'], props),
            time: path(['event', 'details', 'eventTime'], props),
            shortResult: null,
            ...values.details
        }
    })
};

const WorkflowComponents = {
    [PROBATION_EVENT_TYPE]: EventProbationForm,
    [WAITING_EVENT_TYPE]: EventWaitingForWorkForm
};

const getMapBeforeSubmit = {
    [PROBATION_EVENT_TYPE]: (values, props) => {
        const { personState, resultComment } = values.details;
        const excludeReasons = pathOr([], ['event', 'excludeReasons'], props);
        const reasonText = prop('text', find(propEq('id', +personState))(excludeReasons));
        const commentString = `${reasonText} (${resultComment})`;

        return assocPath(['details', 'resultComment'], commentString, workingMapBeforeSubmit(values, props));
    },
    [WAITING_EVENT_TYPE]: workingMapBeforeSubmit
};

export default class EventWorkflowForm extends Component {
    static propTypes = {
        close: PropTypes.func,
        closeModal: PropTypes.func,
        event: PropTypes.object
    }

    render() {
        const EventWorkingComponent = WorkflowComponents[this.props.event.type];
        const mapBeforeSubmit = getMapBeforeSubmit[this.props.event.type];

        return EventWorkingComponent ? (
            <EventWorkingComponent {...this.props} mapBeforeSubmit={mapBeforeSubmit} />
        ) : null
    }
}
